export { default as I18nStore } from './store'
